import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5a9f3d0b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "StereoscopicSectionExamEditorContainer"
};
const _hoisted_2 = {
  class: "ft20"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "主图", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "选项", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_StereoscopicSectionExamShot = _resolveComponent("StereoscopicSectionExamShot");
  const _component_el_col = _resolveComponent("el-col");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_2, "第" + _toDisplayString($props.data.questionIndex + 1) + "题，正确答案：" + _toDisplayString($props.data.rightAnswer), 1), $props.review ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      style: _normalizeStyle({
        color: $props.review.result ? 'green' : 'red'
      }),
      class: "ft20"
    }, "，您的答案: " + _toDisplayString($props.review.answer), 5)) : _createCommentVNode("", true)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "wd100 bothCenter colFlex"
  }, {
    default: _withCtx(() => [_hoisted_3, (_openBlock(), _createBlock(_component_StereoscopicSectionExamShot, {
      img: $data.previewData[$props.data.questionIndex] ? $data.previewData[$props.data.questionIndex].question : null,
      editMode: $props.editMode,
      key: `question${$props.data.questionIndex}`,
      width: "150",
      onSaveImg: _cache[0] || (_cache[0] = url => $options.handleSaveImage(url, 'Q'))
    }, null, 8, ["img", "editMode"]))]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter wd100"
  }, {
    default: _withCtx(() => [_hoisted_4]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter wd100"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 6,
      class: "bothCenter colFlex"
    }, {
      default: _withCtx(() => [(_openBlock(), _createBlock(_component_StereoscopicSectionExamShot, {
        img: $data.previewData[$props.data.questionIndex]?.options ? $data.previewData[$props.data.questionIndex].options['A'] : null,
        editMode: $props.editMode,
        key: `optionA${$props.data.questionIndex}`,
        onSaveImg: _cache[1] || (_cache[1] = url => $options.handleSaveImage(url, 'A'))
      }, null, 8, ["img", "editMode"])), _createElementVNode("span", {
        class: _normalizeClass($props.data.rightAnswer == 'A' ? 'rightAnswer' : '')
      }, "A", 2)]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6,
      class: "bothCenter colFlex"
    }, {
      default: _withCtx(() => [(_openBlock(), _createBlock(_component_StereoscopicSectionExamShot, {
        img: $data.previewData[$props.data.questionIndex]?.options ? $data.previewData[$props.data.questionIndex].options['B'] : null,
        editMode: $props.editMode,
        key: `optionB${$props.data.questionIndex}`,
        onSaveImg: _cache[2] || (_cache[2] = url => $options.handleSaveImage(url, 'B'))
      }, null, 8, ["img", "editMode"])), _createElementVNode("span", {
        class: _normalizeClass($props.data.rightAnswer == 'B' ? 'rightAnswer' : '')
      }, "B", 2)]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6,
      class: "bothCenter colFlex"
    }, {
      default: _withCtx(() => [(_openBlock(), _createBlock(_component_StereoscopicSectionExamShot, {
        img: $data.previewData[$props.data.questionIndex]?.options ? $data.previewData[$props.data.questionIndex].options['C'] : null,
        editMode: $props.editMode,
        key: `optionC${$props.data.questionIndex}`,
        onSaveImg: _cache[3] || (_cache[3] = url => $options.handleSaveImage(url, 'C'))
      }, null, 8, ["img", "editMode"])), _createElementVNode("span", {
        class: _normalizeClass($props.data.rightAnswer == 'C' ? 'rightAnswer' : '')
      }, "C", 2)]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6,
      class: "bothCenter colFlex"
    }, {
      default: _withCtx(() => [(_openBlock(), _createBlock(_component_StereoscopicSectionExamShot, {
        img: $data.previewData[$props.data.questionIndex]?.options ? $data.previewData[$props.data.questionIndex].options['D'] : null,
        editMode: $props.editMode,
        key: `optionD${$props.data.questionIndex}`,
        onSaveImg: _cache[4] || (_cache[4] = url => $options.handleSaveImage(url, 'D'))
      }, null, 8, ["img", "editMode"])), _createElementVNode("span", {
        class: _normalizeClass($props.data.rightAnswer == 'D' ? 'rightAnswer' : '')
      }, "D", 2)]),
      _: 1
    })]),
    _: 1
  })]);
}